import axios from "axios";
import { DEFAULT_LANG } from "constant";
import { getLsObject, isGeneralDomain } from "helper";

const URL = isGeneralDomain() ? `dhgamesdownload`: `garenanow`;
const LOCALIZE = isGeneralDomain() ? `ofa_form`: `ofa_form_garena`;

const cdn = axios.create({
	baseURL: `https://webid.cdn.${URL}.com/gstaticid/trapp/`,
	withCredentials: false
});

const isHavePrefix = (list) =>
	list.some((key) => process.env.REACT_APP_LOCALIZE_NAME?.startsWith(key));

const isUsingTrApp = () => !isHavePrefix(["glb_", "cstm_", "tr_"]);

const combineObjects = (responses, lang) => {
	if (isUsingTrApp()) {
		if (responses.every((response) => response.data[lang])) {
			return responses.reduce((acc, curr) => {
				return { ...acc, ...curr.data[lang] };
			}, {});
		}
		return responses.reduce((acc, curr) => {
			return { ...acc, ...curr.data[DEFAULT_LANG] };
		}, {});
	}
};

export const translate = async (params) => {
	let language = getLsObject("param")?.lang.toUpperCase() || params?.jsonName;
	const main_localize = cdn.get(`${LOCALIZE}.json?${Math.random() * 10000}`);
    const common_localize = cdn.get(`tr_common.json?${Math.floor(Math.random() * 10000)}`);
    const api = [main_localize, common_localize];
	const json = language || DEFAULT_LANG;

	return await Promise.all(api)
		.then((responses) => {
			const transfomed = combineObjects(responses, json);
			return transfomed;
		})
		.catch((err) => {
			if (params?.isRetry) throw err;
			if (err?.status === 404) {
				return translate({
					...params,
					jsonName: DEFAULT_LANG,
					isRetry: true,
				});
			}
			throw err;
		});
};

export const info = async (config) =>
	await axios.get("/api/user_info/", { ...config });

export const list_form = async (config) =>
	await axios.get("/api/form/", { ...config });

export const favorite = async (config) =>
	await axios.post('/api/favorite/', { ...config });

export const remove = async (config) =>
	await axios.post('/api/form/delete/', { ...config });

export const countries = async (config) =>
	await axios.get('/api/regiondata/country_codes/', { ...config });

export const provinces = async (config) =>
	await axios.get('/api/regiondata/provinces/', { ...config });

export const cities = async (config) =>
	await axios.get('/api/regiondata/cities/', { ...config });

export const districts = async (config) =>
	await axios.get('/api/regiondata/districts/', { ...config });

export const form_by_id = async (config) =>
	await axios.get(`/api/form/${config}/`, { ...config });

export const create_form = async (config) =>
	await axios.post('/api/form/create/', { ...config });

export const edit_form = async (config) =>
	await axios.post('/api/form/edit/', { ...config });